import { render } from "./BarangMasuk.vue?vue&type=template&id=3689c2f6&scoped=true"
import script from "./BarangMasuk.vue?vue&type=script&lang=js"
export * from "./BarangMasuk.vue?vue&type=script&lang=js"

import "./BarangMasuk.vue?vue&type=style&index=0&id=3689c2f6&scoped=true&lang=css"
import "./BarangMasuk.vue?vue&type=style&index=1&id=3689c2f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3689c2f6"]])

export default __exports__